module.exports = __webpack_public_path__ + "img/ye.c8aadcda.svg";